export const common = {
  // Header Navigation
  nav: {
    home: 'ANA SAYFA',
    brandStory: 'MARKA HİKAYESİ',
    whoWeServe: 'KİMLERE HİZMET VERİYORUZ',
    products: 'ÜRÜNLER',
    elite: 'ELITE',
    privateLabel: 'ÖZEL MARKA',
    shop: 'MAĞAZA',
    contact: 'İLETİŞİM',
  },

  // Product Categories
  productCategories: {
    // Coffee submenu
    coffee: 'Kahve',
    roastedCoffee: 'Kavrulmuş Kahve',
    pods: 'Pod Kahve',
    compatibleCapsules: 'Uyumlu Kapsüller',
    // HoReCa submenu
    horeca: 'Ek HoReCa Çözümleri',
    milkshakes: 'Milkshake',
    coldGlaze: 'Soğuk Glaze',
    toppingSauce: 'Topping Sos',
    coffeeBarSauce: 'Kahve Barı Sosu',
    fillingSauce: 'Dolgu Sosu',
    fillingFruit: 'Meyve Dolgusu',
    praline: 'Pralin',
    refresher: 'Refresher',
    // Other
    chocolate: 'Çikolata',
    machines: 'Kahve & Çay Makineleri',
    // Elite submenu
    eliteCoffee: 'Kahve',
    eliteMilkshake: 'Milkshake',
    eliteTea: 'Çay',
    eliteChocolate: 'Çikolata',
    colombian: 'Kolombiya',
    ethiopian: 'Etiyopya',
    luxury: 'Luxury Elite',
    eliteRoastedBeans: 'Kavrulmuş Çekirdek',
    elitePods: 'Pod Kahve',
  },

  // Common Actions
  actions: {
    seeDetails: 'Detayları Gör',
    learnMore: 'Daha Fazla Bilgi',
    contactUs: 'Bize Ulaşın',
    viewAll: 'Tümünü Gör',
  },

  // Footer
  footer: {
    tagline: 'Vizyonun forma dönüştüğü yer',
    description: 'Mükemmellik için tasarlanmış premium kahve ve HoReCa çözümleri. İtalyan mirasına dayalı, global misafirperverlik için mühendisliği yapılmış.',
    companyInfo: 'MİACCENDO GIDA SANAYİ VE TİCARET LİMİTED ŞİRKETİ',
    address: 'ADRES',
    email: 'E-POSTA',
    copyright: '© 2026 LUCENDO. Tüm hakları saklıdır.',
    privacyPolicy: 'Gizlilik Politikası',
    terms: 'Şartlar',
    poweredBy: 'Akıllı Mum tarafından desteklenmektedir',
  },
};